export default __webpack_public_path__ + "static/media/nantes10.8ee4754d.jpg";